import type { TBuildingObjectType } from 'shared/types/buildingCard';

/**
 * Подписи детального типа здания (`buildingType`, `parentBuildingType`).
 * Как `BuildingType` монолита (`cian/business_shopping_centers/domain/enums.py`): там, где подписи расходятся
 * с x-* контракта commercial-buildings, на проде видны подписи монолита
 */
export const BUILDING_TYPE_LABELS: Partial<Record<string, string>> = {
  businessCenter: 'Бизнес-центр',
  shoppingAndEntertainmentCenter: 'Торгово-развлекательный центр',
  old: 'Старый фонд',
  officeBuilding: 'Офисное здание',
  businessPark: 'Бизнес-парк',
  officeIndustrialComplex: 'Офисно-производственный комплекс',
  officeAndWarehouseComplex: 'Офисно-складской комплекс',
  warehouseComplex: 'Складской комплекс',
  industrialWarehouseComplex: 'Производственно-складской комплекс',
  logisticsCenter: 'Логистический центр',
  warehouse: 'Склад',
  administrativeBuilding: 'Административное здание',
  industrialPark: 'Индустриальный парк',
  logisticsComplex: 'Логистический комплекс',
  shoppingAndBusinessComplex: 'Торгово-деловой комплекс',
  multifunctionalComplex: 'Многофункциональный комплекс',
  officeAndResidentialComplex: 'Офисно-жилой комплекс',
  tradingOfficeComplex: 'Торгово-офисный комплекс',
  officeAndHotelComplex: 'Офисно-гостиничный комплекс',
  businessCenter2: 'Деловой центр',
  mansion: 'Особняк',
  technopark: 'Технопарк',
  businessQuarter: 'Бизнес-квартал',
  standaloneBuilding: 'Отдельно стоящее здание',
  residentialHouse: 'Жилой дом',
  residentialComplex: 'Жилой комплекс',
  shoppingCenter: 'Торговый центр',
  specializedShoppingCenter: 'Специализированный торговый центр',
  shoppingAndCommunityCenter: 'Торгово-общественный центр',
  outlet: 'Аутлет',
  industrialComplex: 'Производственный комплекс',
  industrialSite: 'Промплощадка',
  manufacturingFacility: 'Производственный цех',
  propertyComplex: 'Имущественный комплекс',
  manufactureBuilding: 'Производственное здание',
  modular: 'Модульное здание',
  free: 'Свободное здание',
  officeAndWarehouse: 'Офисно-складское',
  officeCenter: 'Офисный центр',
  officeQuarter: 'Офисный квартал',
  businessQuarter2: 'Деловой квартал',
  businessHouse: 'Деловой дом',
  tradingHouse: 'Торговый дом',
  officeComplex: 'Офисный комплекс',
  tradeAndExhibitionComplex: 'Торгово-выставочный комплекс',
  shoppingComplex: 'Торговый комплекс',
  logisticsPark: 'Логистический парк',
  shoppingAndWarehouseComplex: 'Торгово-складской комплекс',
};

/**
 * Сокращение типа здания каталога: «БЦ», «ТЦ», «СК».
 * Как краткие названия `_get_bs_center_title` и `bsCenterType` бандла монолита
 */
export const BUILDING_OBJECT_TYPE_ABBREVIATIONS: Record<TBuildingObjectType, string> = {
  businessCenter: 'БЦ',
  shoppingCenter: 'ТЦ',
  warehouse: 'СК',
};
